import { logger } from '@gem/modules/logger';

import Entities from 'STORE';

// TODO: check if need this task any more
export const getFriends = async () => {
  try {
    Entities.usersStore.setIsUserContactsLoading(true);

    // const response = await api.relationships.getFriendsData();
    // const { users } = response;

    const users = [];

    const contacts = users.filter((x) => x.id !== Entities.usersStore.Me.id);

    Entities.usersStore.add(contacts);

    Entities.usersStore.setContacts(contacts);
    Entities.usersStore.setIsUserContactsLoading(false);
  } catch (error) {
    logger.get('API').error('api.relationships.getFriendsData', error);
  } finally {
    Entities.usersStore.setLoadedContacts(true);
  }
};
